import { useEffect, useRef } from 'react';

const useBorderRotation = (loading: boolean, speed = 0) => {
	const boxRef = useRef<HTMLDivElement | null>(null);
	const lastUpdateTime = useRef<number>(0);

	useEffect(() => {
		if (!loading) return;

		const boxElement = boxRef.current;
		if (!boxElement) return;

		const rotateBox = (timestamp: number) => {
			// If speed is 0, update every frame (no throttling)
			if (speed === 0 || timestamp - lastUpdateTime.current >= speed) {
				const currentAngle = parseFloat(
					boxElement.style.getPropertyValue('--angle') || '0'
				);
				boxElement.style.setProperty(
					'--angle',
					`${(currentAngle + 1) % 360}deg`
				);
				lastUpdateTime.current = timestamp;
			}
			requestAnimationFrame(rotateBox);
		};

		requestAnimationFrame(rotateBox);
	}, [loading, speed]);

	return boxRef;
};

export { useBorderRotation };
